import type { GetIndicatorResultByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetIndicatorResultByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetIndicatorResultByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetIndicatorResultByIdArgs = {
  id: string;
};

export const useGetIndicatorResultById = createQueryHook<
  UseGetIndicatorResultByIdArgs,
  GetIndicatorResultByIdResponseRow[] | undefined,
  GetIndicatorResultByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.indicator.indicatorResultById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ indicator_result: data ?? [] }),
  graphqlDocument: GetIndicatorResultByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
});
